module.exports = __webpack_public_path__ + "img/icon-billing-info.ff793d46.svg";